import { render, staticRenderFns } from "./HairLossSpecialist.vue?vue&type=template&id=aa2b63d2"
import script from "./HairLossSpecialist.vue?vue&type=script&lang=js"
export * from "./HairLossSpecialist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports